import { Component, OnInit, Injector, ElementRef, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseResourceFormComponent, Contrato, LoginPublico,
  GlobalService, DateFormatPipe
} from 'eddydata-lib';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { ContratoService } from '../service/contrato.service';

@Component({
  selector: 'lib-contrato-shw',
  templateUrl: './contrato-shw.component.html'
})
export class ContratoShwComponent extends BaseResourceFormComponent<Contrato, LoginPublico> implements OnInit {

  /**
   * Declaração de variáveis
   */
  @Input() sistema: string;
  private pagina: string;
  private data1: string;
  private data2: string;
  private filtro: string;
  private datepipe: DatePipe;
  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected globalService: GlobalService,
    protected contratoService: ContratoService) {
    super(new Contrato(), injector, Contrato.converteJson, contratoService);
    this.datepipe = new DatePipe('pt');
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        this.pagina = params['pagina'];
        this.data1 = params['data1'];
        this.data2 = params['data2'];
        this.filtro = params['filtro'];
      });
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      numero: [null, [Validators.required]],
      valor_contrato: 0,
      data_inicio: [null, [Validators.required]],
      data_termino: [null, [Validators.required]],
      finalidade: [null, [Validators.required]],
      favorecido: this.fb.group({
        cpf_cnpj: [null, [Validators.required]],
        nome: [null, [Validators.required]]
      }),
      prazo: this.fb.group({
        id: [null, [Validators.required]],
        nome: [null, [Validators.required]]
      }),
      objeto: [null, [Validators.required]],
    });
    this.entidadeForm.disable();
  }

  protected afterLoad() {
    this.entidade.data_inicio = new DateFormatPipe().transform(this.entidade.data_inicio, []);
    this.entidade.data_termino = new DateFormatPipe().transform(this.entidade.data_termino, []);
  }

  protected parametrosExtras(): {} {
    return { relations: 'favorecido,orgao,prazo' };
  }

  protected afterInit(): void {
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
  }

  protected campoFoco(): ElementRef {
    return null;
  }

  protected beforeSubmit(): void {
  }

  protected afterSubmit(entidade: Contrato): void {
  }

  public voltar() {
    const dt1 = this.datepipe.transform(this.data1, 'yyyy-MM-dd', 'GMT');
    const dt2 = this.datepipe.transform(this.data2, 'yyyy-MM-dd', 'GMT');
    if (!this.filtro || this.filtro === '') {
      this.router.navigate([`/contratos/pesquisa`, this.pagina, dt1, dt2]);
    } else {
      this.router.navigate([`/contratos/pesquisa`, this.pagina, dt1, dt2, this.filtro]);
    }
  }

}
